import { TranslateService } from '@ngx-translate/core';

/**
 * De tekst bij een fout van het platform, in de taal van de gebruiker.
 *
 * Het platform stuurt bij een fout een vaste code (`Key`) en een Engelse
 * tekst (`Message`, `message`, `reden` of `error`, afhankelijk van het
 * adres). Staat de code in de taalbestanden onder `API_ERRORS`, dan komt de
 * vertaling op het scherm; anders de Engelse tekst van het platform; en
 * anders de standaardtekst van het scherm zelf. Zo wordt een melding
 * meertalig door alleen een regel in de taalbestanden toe te voegen.
 */
export function apiFoutTekst(translate: TranslateService, fout: unknown, standaard: string): string {
  const inhoud = (fout as { error?: unknown } | null | undefined)?.error;
  const body = inhoud && typeof inhoud === 'object' ? (inhoud as Record<string, unknown>) : null;
  const code = body?.['Key'] ?? body?.['key'];
  if (typeof code === 'string' && /^[a-z0-9_]+$/.test(code)) {
    const sleutel = `API_ERRORS.${code}`;
    const vertaald = translate.instant(sleutel);
    if (typeof vertaald === 'string' && vertaald && vertaald !== sleutel) {
      return vertaald;
    }
  }
  for (const veld of ['Message', 'message', 'reden', 'error']) {
    const tekst = body?.[veld];
    if (typeof tekst === 'string' && tekst.trim()) {
      return tekst.trim();
    }
  }
  return standaard;
}
